import * as $ from 'jquery';
export default class QuestionAnswer {
	private $wrapper: JQuery = $('.questionAnswer');
	private $triggers: JQuery = $('.questionAnswer__nav a');
	private $targets: JQuery = $('.questionAnswer__panel');
	private selector_triggers: string = '.questionAnswer__nav a';

	getIdFromHREF(HREF: string) {
		return HREF.split('#')[1];
	}
	setupTargets() {
		this.$targets.slideUp(0);
	}
	setupTriggers() {
		this.$wrapper.on('click', this.selector_triggers, (event) => {
			event.preventDefault();
			const element: HTMLElement = event.currentTarget as HTMLElement;
			this.toggleTriggers(element);
			this.toggleTargets(element);
		});
		this.$triggers.removeClass('target');
	}
	toggleTargeted(): void {
		let hash = window.location.hash;
		let category = hash.split(':');
		if (hash && category && this.$triggers.filter('[href*="' + category[0] + '"]')){
			this.$triggers.removeClass('target');
			this.$triggers.filter('[href*="' + category[0] + '"]').addClass('target');
			this.$targets.filter('[id="' + category[0].substr(1) + '"]').slideDown();
		} else {
			this.$targets.slideUp(0).first().slideDown(0);
			this.$triggers.first().addClass('target');
		}
	}
	toggleTargets(element: HTMLElement) {
		const targetId = this.getIdFromHREF(element.getAttribute('href'));
		this.$targets.slideUp();
		this.$targets.filter('[id="' + targetId + '"]').slideDown();
		history.replaceState(undefined, undefined, location.pathname + '#' + targetId);
	}
	toggleTriggers(element: HTMLElement) {
		this.$triggers.removeClass('target');
		this.$triggers.filter(element).addClass('target');
	}
	constructor() {
		if (!this.$wrapper) {
			return;
		}
		this.setupTargets();
		this.setupTriggers();
		this.toggleTargeted();
	}
}
